import { Feature } from '../../types/service';

export const canvaFeatures: Feature[] = [
  {
    iconName: "Paintbrush",
    title: "Outils premium",
    description: "Accès à tous les outils de design premium de Canva Pro"
  },
  {
    iconName: "Layout",
    title: "Templates exclusifs",
    description: "Des milliers de templates professionnels exclusifs"
  },
  {
    iconName: "Image",
    title: "Banque d'images",
    description: "Plus de 100 millions d'images, vidéos et éléments graphiques"
  }
];